import { amountToDisplayValue } from '@billy/design-system'

import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

import { BACK_TO_SCHOOL_CURRENCY } from '../constants/backToSchoolCurrency'
import type { BackToSchoolOffer } from '../types/backToSchoolOffer'

const START_PROMO_CODE = 'RENTREE-2026'
const PLUS_PROMO_CODE = 'SUPER-RENTREE-2026'
const START_PROMO_PRICE = 92.5
const PLUS_PROMO_PRICE = 150
const START_SAVE_PERCENT = 30
const PLUS_SAVE_PERCENT = 50

export const getBackToSchoolOffers = (): BackToSchoolOffer[] => [
  {
    descriptionKey: 'back_to_school.plan.start.description',
    featureKeys: [
      'back_to_school.plan.start.feature.electronic_invoicing',
      'back_to_school.plan.start.feature.customising_quotes_and_invoices',
      'back_to_school.plan.start.feature.deposit_invoices_discounts',
      'back_to_school.plan.start.feature.pay_by_card',
    ],
    featuresHeaderKey: 'back_to_school.plan.start.features_header',
    noteTooltipKey: 'back_to_school.plan.start.note_tooltip',
    plan: SubscriptionPlan.Start,
    promoCode: START_PROMO_CODE,
    promoPrice: amountToDisplayValue(START_PROMO_PRICE, false, BACK_TO_SCHOOL_CURRENCY),
    promoPriceAmount: START_PROMO_PRICE,
    savePercent: START_SAVE_PERCENT,
  },
  {
    descriptionKey: 'back_to_school.plan.plus.description',
    featureKeys: [
      'back_to_school.plan.plus.feature.detailed_sales_report',
      'back_to_school.plan.plus.feature.multi_user_access',
      'back_to_school.plan.plus.feature.recurring_billing',
      'back_to_school.plan.plus.feature.simplified_bank_reconciliation',
    ],
    featuresHeaderKey: 'back_to_school.plan.plus.features_header',
    isHighlighted: true,
    noteTooltipKey: 'back_to_school.plan.plus.note_tooltip',
    plan: SubscriptionPlan.Plus,
    promoCode: PLUS_PROMO_CODE,
    promoPrice: amountToDisplayValue(PLUS_PROMO_PRICE, true, BACK_TO_SCHOOL_CURRENCY),
    promoPriceAmount: PLUS_PROMO_PRICE,
    savePercent: PLUS_SAVE_PERCENT,
  },
]
